import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import axios from 'axios'
import EventBus from './utils/EventBus'

Vue.use(ElementUI)
Vue.config.productionTip = false

const baseURL = '/api'
  
axios.defaults.baseURL = baseURL

// 请求拦截器
axios.interceptors.request.use(
  config => {
    // 添加JWT到请求头
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    
    // 添加设备类型和会话ID到请求头
    const deviceType = localStorage.getItem('deviceType') || 'unknown'
    const sessionId = localStorage.getItem('sessionId') || 'unknown'
    
    config.headers['Device-Type'] = deviceType
    config.headers['Session-Id'] = sessionId
    
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截器
axios.interceptors.response.use(
  response => {
    return response
  },
  error => {
    if (error.response && error.response.status === 401) {
      // JWT失效，清除本地存储并跳转到登录页
      localStorage.removeItem('token')
      localStorage.removeItem('teacherInfo')
      localStorage.removeItem('deviceType')
      localStorage.removeItem('sessionId')
      
      const currentPath = window.location.pathname + window.location.search
      
      const specialPaths = ['/newclass', '/joinclass', '/bindteacher', '/newclassmobile', '/joinclassmobile', '/bindteachermobile']
      const isSpecialPath = specialPaths.some(path => currentPath.startsWith(path))
      
      if (window.location.pathname.includes('/mobile') || window.location.pathname.includes('/loginmobile')) {
        if (isSpecialPath) {
          window.location.href = '/loginmobile?redirect=' + encodeURIComponent(currentPath)
        } else {
          window.location.href = '/loginmobile'
        }
      } else {
        if (isSpecialPath) {
          window.location.href = '/login?redirect=' + encodeURIComponent(currentPath)
        } else {
          window.location.href = '/login'
        }
      }
    }
    return Promise.reject(error)
  }
)

Vue.prototype.$http = axios

// 监听导航栏状态变化，动态调整消息提示框位置
EventBus.$on('navbar-visibility-changed', ({ visible }) => {
  const body = document.body
  if (visible) {
    // 导航栏显示，移除navbar-hidden类
    body.classList.remove('navbar-hidden')
  } else {
    // 导航栏隐藏，添加navbar-hidden类
    body.classList.add('navbar-hidden')
  }
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')